var _path, _path2, _path3, _path4, _g, _g2, _g3, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 175C59.3774 175 25.8 141.423 25.8 100C25.8 58.5774 59.3774 25 100.8 25C142.223 25 175.8 58.5774 175.8 100C175.8 141.423 142.223 175 100.8 175Z",
    fill: "url(#paint0_linear_26801_1425)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9708 148.722C33.04 122.702 25.9366 96.1919 20.6608 69.1923C19.8731 65.161 21.7325 61.2736 25.07 59.9207C43.2124 52.5655 61.9783 47.5372 81.3678 44.8357C84.9345 44.3389 88.4885 46.7757 89.8219 50.6607C98.7527 76.6809 105.856 103.191 111.132 130.191C111.92 134.222 110.06 138.109 106.723 139.462C88.5805 146.817 69.8146 151.846 50.4251 154.547C46.8582 155.044 43.3042 152.607 41.9708 148.722Z",
    fill: "url(#paint1_linear_26801_1425)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9652 107.717C28.317 109.048 28.6733 110.378 29.0342 111.707C29.2514 112.506 30.0755 112.978 30.875 112.761C31.6744 112.544 32.1465 111.72 31.9293 110.92C31.5702 109.598 31.2156 108.275 30.8656 106.951C30.654 106.15 29.8331 105.672 29.0322 105.884C28.2313 106.095 27.7535 106.916 27.9652 107.717ZM28.2357 102.805C29.0387 102.602 29.5249 101.786 29.3216 100.983C28.9853 99.6547 28.6536 98.3256 28.3265 96.9952C28.1287 96.1908 27.3162 95.699 26.5117 95.8968C25.7073 96.0946 25.2155 96.9071 25.4133 97.7115C25.7421 99.0486 26.0754 100.384 26.4133 101.719C26.6167 102.522 27.4326 103.008 28.2357 102.805ZM31.7245 115.825C30.9273 116.051 30.4639 116.88 30.6893 117.677C31.0639 119.002 31.4431 120.325 31.8269 121.648C32.0579 122.443 32.89 122.901 33.6856 122.67C34.4812 122.439 34.939 121.607 34.708 120.811C34.3261 119.496 33.9488 118.179 33.5761 116.861C33.3506 116.064 32.5217 115.6 31.7245 115.825ZM25.7684 92.8048C26.5748 92.6153 27.075 91.808 26.8855 91.0015C26.5722 89.6681 26.2635 88.3334 25.9593 86.9975C25.7754 86.1898 24.9715 85.6841 24.1637 85.868C23.356 86.0519 22.8503 86.8558 23.0342 87.6636C23.3399 89.0062 23.6502 90.3475 23.9651 91.6877C24.1545 92.4941 24.9619 92.9943 25.7684 92.8048ZM34.5878 125.719C33.7947 125.959 33.3455 126.795 33.5847 127.589C33.9821 128.907 34.384 130.223 34.7906 131.539C35.0352 132.33 35.8751 132.774 36.6666 132.529C37.4581 132.285 37.9014 131.445 37.6568 130.653C37.2523 129.344 36.8524 128.034 36.457 126.723C36.2178 125.929 35.381 125.48 34.5878 125.719ZM23.4737 82.7637C24.2833 82.5881 24.7973 81.7895 24.6217 80.9799C24.3314 79.6413 24.0457 78.3016 23.7645 76.9606C23.5945 76.1498 22.7994 75.6303 21.9886 75.8003C21.1778 75.9703 20.6584 76.7654 20.8284 77.5762C21.111 78.9239 21.3981 80.2704 21.6899 81.6157C21.8655 82.4253 22.6641 82.9393 23.4737 82.7637ZM37.6211 135.563C36.8322 135.815 36.3976 136.66 36.6503 137.449C37.0703 138.76 37.4948 140.069 37.9239 141.378C38.1821 142.165 39.0295 142.594 39.8167 142.336C40.6039 142.077 41.0327 141.23 40.7746 140.443C40.3476 139.141 39.9251 137.838 39.5073 136.533C39.2545 135.745 38.4101 135.31 37.6211 135.563ZM21.352 72.6847C22.1645 72.523 22.6921 71.7333 22.5305 70.9208C22.3968 70.249 22.2643 69.577 22.1329 68.9047C22.0091 68.2712 21.9631 67.6451 21.987 67.0393C22.0196 66.2115 21.375 65.514 20.5473 65.4814C19.7195 65.4487 19.022 66.0933 18.9893 66.9211C18.9562 67.7599 19.0203 68.6187 19.1886 69.48C19.3207 70.1557 19.4538 70.8311 19.5882 71.5062C19.7498 72.3187 20.5395 72.8463 21.352 72.6847ZM40.8232 145.352C40.0388 145.618 39.6187 146.47 39.8849 147.255C40.1061 147.907 40.3285 148.558 40.552 149.209C40.8369 150.039 41.2108 150.815 41.6589 151.525C42.1011 152.225 43.0274 152.435 43.728 151.993C44.4285 151.551 44.638 150.624 44.1958 149.924C43.8722 149.411 43.5991 148.846 43.3895 148.235C43.1671 147.587 42.9459 146.939 42.7257 146.291C42.4595 145.506 41.6077 145.086 40.8232 145.352ZM22.0481 62.0592C22.5898 62.6859 23.5371 62.7548 24.1638 62.213C24.6012 61.8349 25.0937 61.5296 25.6335 61.3108L25.6335 61.3108C26.2318 61.0682 26.8307 60.8283 27.4303 60.5908C28.2005 60.2858 28.5776 59.4142 28.2726 58.6439C27.9676 57.8737 27.096 57.4965 26.3257 57.8016C25.7186 58.042 25.1122 58.285 24.5064 58.5305M22.0481 62.0592C21.5063 61.4325 21.5752 60.4853 22.2019 59.9435L22.0481 62.0592ZM46.7388 154.206C46.5829 155.02 47.1162 155.805 47.9298 155.961C48.8093 156.13 49.719 156.16 50.632 156.033L50.4251 154.547L50.632 156.033C51.2794 155.943 51.9261 155.85 52.5721 155.754C53.3917 155.634 53.958 154.871 53.837 154.052C53.716 153.232 52.9536 152.666 52.1341 152.787C51.4961 152.881 50.8574 152.972 50.2181 153.062C49.6412 153.142 49.0621 153.124 48.4942 153.015C47.6805 152.859 46.8946 153.392 46.7388 154.206ZM22.2019 59.9435C22.8794 59.3578 23.6521 58.8769 24.5064 58.5306L22.2019 59.9435ZM30.9289 57.6294C31.215 58.4068 32.0771 58.8052 32.8546 58.5191C34.0664 58.0732 35.2809 57.6376 36.4982 57.2122C37.2803 56.9389 37.6927 56.0834 37.4194 55.3014C37.1461 54.5193 36.2906 54.1069 35.5086 54.3802C34.2758 54.8109 33.0458 55.2521 31.8186 55.7036C31.0412 55.9897 30.6428 56.8519 30.9289 57.6294ZM56.6447 153.602C56.7857 154.418 57.5618 154.966 58.3781 154.825C59.6666 154.602 60.9524 154.369 62.2354 154.126C63.0493 153.972 63.584 153.187 63.4296 152.373C63.2753 151.559 62.4903 151.024 61.6764 151.179C60.4096 151.419 59.1399 151.649 57.8675 151.869C57.0512 152.01 56.5037 152.786 56.6447 153.602ZM40.1149 54.3966C40.3688 55.1852 41.2139 55.6186 42.0024 55.3648C43.2311 54.9692 44.4624 54.584 45.6965 54.2091C46.4892 53.9683 46.9366 53.1305 46.6958 52.3378C46.455 51.5452 45.6172 51.0978 44.8245 51.3386C43.5746 51.7183 42.3274 52.1085 41.0831 52.5091C40.2945 52.763 39.8611 53.608 40.1149 54.3966ZM66.2164 151.809C66.3908 152.619 67.1888 153.134 67.9986 152.959C69.2765 152.684 70.5517 152.398 71.824 152.102C72.6309 151.914 73.1327 151.108 72.945 150.301C72.7572 149.494 71.9508 148.992 71.144 149.18C69.8878 149.473 68.6287 149.755 67.367 150.026C66.5571 150.201 66.042 150.999 66.2164 151.809ZM75.706 149.622C75.9138 150.424 76.7324 150.906 77.5343 150.698C78.7994 150.37 80.0616 150.032 81.3211 149.684C82.1194 149.462 82.5875 148.636 82.3665 147.838C82.1454 147.039 81.319 146.571 80.5206 146.792C79.2771 147.137 78.0309 147.47 76.7819 147.794C75.9799 148.002 75.4983 148.82 75.706 149.622ZM49.4264 51.5452C49.6474 52.3436 50.4738 52.8116 51.2722 52.5906C52.5157 52.2463 53.7619 51.9124 55.0109 51.5888C55.8129 51.381 56.2945 50.5625 56.0868 49.7605C55.879 48.9586 55.0605 48.4769 54.2585 48.6847C52.9935 49.0125 51.7312 49.3507 50.4718 49.6994C49.6734 49.9204 49.2053 50.7468 49.4264 51.5452ZM58.8479 49.0817C59.0356 49.8886 59.842 50.3904 60.6488 50.2026C61.9051 49.9103 63.1641 49.6282 64.4258 49.3564C65.2357 49.182 65.7508 48.3841 65.5764 47.5742C65.402 46.7644 64.6041 46.2493 63.7942 46.4237C62.5163 46.6989 61.2411 46.9846 59.9688 47.2807C59.1619 47.4685 58.6601 48.2748 58.8479 49.0817ZM85.0971 147.045C85.3379 147.838 86.1756 148.285 86.9683 148.044C88.2182 147.665 89.4654 147.274 90.7097 146.874C91.4983 146.62 91.9317 145.775 91.6779 144.986C91.424 144.198 90.5789 143.764 89.7904 144.018C88.5618 144.414 87.3304 144.799 86.0963 145.174C85.3036 145.415 84.8563 146.252 85.0971 147.045ZM69.5574 45.2568C68.7435 45.4112 68.2088 46.1961 68.3632 47.01C68.5175 47.8239 69.3025 48.3586 70.1164 48.2043C71.3833 47.964 72.6529 47.734 73.9253 47.5143C74.7416 47.3733 75.2891 46.5972 75.1481 45.7809C75.0071 44.9645 74.2311 44.417 73.4147 44.558C72.1262 44.7806 70.8404 45.0135 69.5574 45.2568ZM94.3734 144.082C94.6467 144.864 95.5022 145.276 96.2843 145.003C97.517 144.572 98.747 144.131 99.9742 143.679C100.752 143.393 101.15 142.531 100.864 141.754C100.578 140.976 99.7157 140.578 98.9382 140.864C97.7264 141.31 96.5119 141.745 95.2946 142.171C94.5126 142.444 94.1001 143.299 94.3734 144.082ZM103.52 140.739C103.825 141.509 104.697 141.886 105.467 141.581C106.074 141.341 106.681 141.098 107.286 140.852L106.773 139.586L107.286 140.852C108.141 140.506 108.913 140.025 109.591 139.439C110.218 138.897 110.286 137.95 109.745 137.324C109.203 136.697 108.256 136.628 107.629 137.17C107.191 137.548 106.699 137.853 106.159 138.072C105.561 138.315 104.962 138.555 104.363 138.792C103.592 139.097 103.215 139.969 103.52 140.739ZM77.9558 45.3314C78.0768 46.1509 78.8392 46.7172 79.6588 46.5962C80.2967 46.5021 80.9354 46.4104 81.5748 46.3214C82.1516 46.241 82.7307 46.2592 83.2986 46.368C84.1122 46.5239 84.8981 45.9906 85.054 45.177C85.2099 44.3634 84.6767 43.5774 83.863 43.4216C82.9835 43.2531 82.0738 43.2229 81.1608 43.3501L81.3677 44.8355L81.1608 43.3501C80.5134 43.4403 79.8667 43.533 79.2207 43.6284C78.4011 43.7494 77.8348 44.5118 77.9558 45.3314ZM88.0647 47.3902C87.3641 47.8323 87.1547 48.7587 87.5969 49.4593C87.9204 49.9719 88.1936 50.5371 88.4031 51.1476C88.6255 51.7956 88.8468 52.4438 89.0669 53.0924C89.3332 53.8769 90.1849 54.297 90.9694 54.0307C91.7539 53.7645 92.174 52.9127 91.9077 52.1282C91.6865 51.4764 91.4641 50.8249 91.2406 50.1737C90.9557 49.3436 90.5818 48.5679 90.1338 47.858C89.6916 47.1575 88.7653 46.948 88.0647 47.3902ZM111.245 133.902C112.073 133.934 112.771 133.29 112.803 132.462C112.836 131.623 112.772 130.764 112.604 129.903C112.472 129.227 112.339 128.552 112.204 127.877C112.043 127.064 111.253 126.537 110.441 126.698C109.628 126.86 109.101 127.65 109.262 128.462C109.396 129.134 109.528 129.806 109.66 130.478C109.783 131.112 109.83 131.738 109.806 132.344C109.773 133.171 110.418 133.869 111.245 133.902ZM91.976 57.0473C91.1888 57.3054 90.7599 58.1528 91.0181 58.94C91.4451 60.2419 91.8675 61.5451 92.2854 62.8495C92.5381 63.6384 93.3826 64.073 94.1715 63.8203C94.9604 63.5676 95.3951 62.7231 95.1423 61.9342C94.7224 60.6233 94.2978 59.3136 93.8687 58.0051C93.6105 57.218 92.7631 56.7891 91.976 57.0473ZM109.804 123.583C110.615 123.413 111.134 122.617 110.964 121.807C110.682 120.459 110.395 119.112 110.103 117.767C109.927 116.958 109.129 116.444 108.319 116.619C107.509 116.795 106.995 117.593 107.171 118.403C107.461 119.742 107.747 121.081 108.028 122.422C108.198 123.233 108.993 123.753 109.804 123.583ZM95.1261 66.8537C94.3346 67.0983 93.8912 67.9382 94.1358 68.7297C94.5403 70.0387 94.9403 71.3489 95.3357 72.6603C95.5748 73.4535 96.4117 73.9026 97.2048 73.6635C97.998 73.4243 98.4471 72.5875 98.208 71.7943C97.8106 70.4763 97.4086 69.1595 97.0021 67.844C96.7575 67.0525 95.9176 66.6091 95.1261 66.8537ZM107.629 113.515C108.437 113.331 108.942 112.527 108.758 111.719C108.453 110.377 108.142 109.035 107.828 107.695C107.638 106.889 106.831 106.389 106.024 106.578C105.218 106.768 104.718 107.575 104.907 108.381C105.22 109.715 105.529 111.05 105.833 112.385C106.017 113.193 106.821 113.699 107.629 113.515ZM98.107 76.7129C97.3114 76.9438 96.8537 77.7759 97.0846 78.5715C97.4665 79.8872 97.8438 81.2041 98.2166 82.5222C98.442 83.3194 99.271 83.7829 100.068 83.5575C100.865 83.332 101.329 82.503 101.103 81.7059C100.729 80.3811 100.35 79.0576 99.9657 77.7353C99.7348 76.9397 98.9026 76.4819 98.107 76.7129ZM105.281 103.486C106.085 103.288 106.577 102.476 106.379 101.671C106.051 100.334 105.717 98.9985 105.379 97.6639C105.176 96.8608 104.36 96.3746 103.557 96.578C102.754 96.7814 102.268 97.5972 102.471 98.4003C102.807 99.7282 103.139 101.057 103.466 102.388C103.664 103.192 104.476 103.684 105.281 103.486ZM100.918 86.6219C100.118 86.8391 99.6462 87.6632 99.8633 88.4627C100.222 89.7847 100.577 91.1079 100.927 92.4323C101.139 93.2333 101.96 93.711 102.76 93.4993C103.561 93.2877 104.039 92.4668 103.827 91.6659C103.476 90.3348 103.119 89.0049 102.758 87.6762C102.541 86.8768 101.717 86.4048 100.918 86.6219Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.822 148.722C167.753 122.702 174.856 96.1919 180.132 69.1923C180.92 65.161 179.06 61.2736 175.723 59.9207C157.58 52.5655 138.814 47.5372 119.425 44.8357C115.858 44.3389 112.304 46.7757 110.971 50.6607C102.04 76.6809 94.9366 103.191 89.6608 130.191C88.8731 134.222 90.7325 138.109 94.0698 139.462C112.212 146.817 130.978 151.846 150.368 154.547C153.935 155.044 157.489 152.607 158.822 148.722Z",
    fill: "url(#paint2_linear_26801_1425)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_1425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.972 97.3507L113.158 83.4673C112.239 83.2209 111.675 82.3451 111.899 81.5106C112.123 80.6762 113.049 80.1996 113.968 80.446L165.782 94.3295C166.701 94.5758 167.265 95.4516 167.042 96.2861C166.818 97.1205 165.892 97.5971 164.972 97.3507Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_26801_1425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.125 107.976L110.312 94.0924C109.392 93.8461 108.828 92.9703 109.052 92.1358C109.276 91.3013 110.202 90.8248 111.121 91.0711L162.935 104.955C163.854 105.201 164.418 106.077 164.195 106.911C163.971 107.746 163.045 108.222 162.125 107.976Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_26801_1425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.371 111.659L107.464 104.718C106.545 104.471 105.981 103.595 106.205 102.761C106.428 101.927 107.355 101.45 108.274 101.696L134.181 108.638C135.1 108.884 135.664 109.76 135.44 110.595C135.217 111.429 134.29 111.906 133.371 111.659Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0591 56.2713C84.0324 57.3922 76.7202 61.7815 73.3365 65.8419C72.6294 66.6904 71.3683 66.8051 70.5197 66.098C69.6712 65.3908 69.5565 64.1297 70.2637 63.2812C74.38 58.3415 82.6678 53.5309 92.5661 52.3018C101.309 51.2161 111.357 52.9158 120.999 59.7786C120.684 58.7154 120.24 57.6382 119.604 56.6215C119.019 55.6848 119.303 54.4509 120.24 53.8655C121.177 53.2801 122.411 53.5648 122.996 54.5015C125.28 58.1563 125.627 62.2374 125.794 64.4081C125.839 64.9925 125.626 65.5671 125.21 65.9802C124.794 66.3933 124.218 66.6033 123.634 66.5546C122.756 66.4815 121.182 66.4556 119.461 66.6379C117.716 66.8225 115.987 67.2041 114.695 67.8504C113.707 68.3444 112.505 67.9439 112.011 66.9559C111.517 65.968 111.918 64.7666 112.906 64.2727C114.569 63.4411 116.508 62.9911 118.274 62.7523C109.612 56.7372 100.737 55.3179 93.0591 56.2713Z",
    fill: "url(#paint3_linear_26801_1425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_1425",
    x: 111.85,
    y: 79.3811,
    width: 55.2405,
    height: 18.0346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1425"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1425"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1425",
    result: "effect2_innerShadow_26801_1425"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_26801_1425",
    x: 109.003,
    y: 90.0063,
    width: 55.2405,
    height: 18.0346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1425"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1425"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1425",
    result: "effect2_innerShadow_26801_1425"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_26801_1425",
    x: 106.156,
    y: 100.631,
    width: 29.3333,
    height: 11.0928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1425"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1425"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1425",
    result: "effect2_innerShadow_26801_1425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1425",
    x1: 25.8,
    y1: 36.7188,
    x2: 168.769,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1425",
    x1: 31.3,
    y1: 79,
    x2: 115.179,
    y2: 103.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1425",
    x1: 170.848,
    y1: 109.325,
    x2: 98.9452,
    y2: 90.0584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1425",
    x1: 75.9251,
    y1: 52.0001,
    x2: 91.6362,
    y2: 86.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialog);
export default __webpack_public_path__ + "static/media/Dialog.328324de788515b2675806d7dafbd630.svg";
export { ForwardRef as ReactComponent };